import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import {statusColor} from '../variables/index'
import {Badge, Tooltip} from 'antd'

class Status extends Component {
  render() {
    const {value, tooltip} = this.props
    const SpanValue = () => <span style={{marginLeft: '10px'}}>{value}</span>
    return (
      <Fragment>
        <Badge
          dot
          style={{
            background: statusColor[value],
          }}
        />
        {tooltip ? (
          <Tooltip {...this.props} title="Status">
            <SpanValue />
          </Tooltip>
        ) : (
          <SpanValue />
        )}
      </Fragment>
    )
  }
}

Status.propTypes = {
  value: PropTypes.string.isRequired,
  tooltip: PropTypes.bool.isRequired,
}
Status.defaultProps = {value: '', tooltip: true}

export default Status
